import { useCallback, useEffect, useRef } from "react"

const STORAGE_KEY = "project_planning.tips"
const STREAK = 3

const seenTips = () => {
  try { return new Set(JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]")) } catch (_error) { return new Set() }
}

const remember = seen => {
  try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen])) } catch (_error) { /* private mode */ }
}

const useTips = ({ notify, canWrite }) => {
  const streak = useRef({ signature: null, count: 0 })

  const tip = useCallback(key => {
    const seen = seenTips()
    if (seen.has(key)) return
    seen.add(key)
    remember(seen)
    notify(I18n.t(`project_planning.tips.${key}`, { alt: /Mac|iPhone|iPad/.test(navigator.platform || "") ? "⌥" : "Alt" }), "tip")
  }, [notify])

  const observeCreate = useCallback(({ projectId, userIds, dates }, how) => {
    if (how === "drag") tip("duplicate")
    if (dates.length !== 1 || userIds.length !== 1) {
      streak.current = { signature: null, count: 0 }
      return
    }
    const signature = `${projectId}|${userIds[0]}`
    streak.current = signature === streak.current.signature
      ? { signature, count: streak.current.count + 1 }
      : { signature, count: 1 }
    if (streak.current.count >= STREAK) tip("range")
  }, [tip])

  useEffect(() => {
    if (canWrite && new Date().getDay() === 5) tip("copy_week")
  }, [canWrite, tip])

  return { observeCreate }
}

export default useTips
